import { useMemo, useState } from 'react';

import qs, { IParseOptions } from 'qs';
import { useLocation } from 'react-router-dom';

import { IWebQueryStringParams } from './types';

export const queryStringParams = (search: string, options?: IParseOptions) => {
  return qs.parse(search, { ignoreQueryPrefix: true, ...options }) as IWebQueryStringParams;
};

export const useQueryParams = (options?: IParseOptions): IWebQueryStringParams => {
  const location = useLocation();

  const search = location.search;

  const [qsOptions] = useState(options);

  const query = useMemo(() => queryStringParams(search, qsOptions), [search, qsOptions]);

  return query;
};
